import {ProductStatisticsCreateDto, ProductStatisticsUpdateDto} from "../../../api";
import {CrudFormItemProps, CrudFormModal, nameof} from "digimuth-components/dist";

const formItems: CrudFormItemProps[] = [
    {
        name: nameof<ProductStatisticsCreateDto>("header"),
        rules: [
            {required: true, message: 'To pole jest wymagane'}
        ],
        label: "Nagłówek"
    },
    {
        name: nameof<ProductStatisticsCreateDto>("content"),
        rules: [
            {required: true, message: 'To pole jest wymagane'}
        ],
        label: "Tekst"
    },

];

export default function ProductStatisticsModalForm(props: ProductStatisticsModalProps) {
    return <CrudFormModal
        formItems={formItems}
        onSubmit={props.onSubmit}
        forceRender={true}
        destroyOnClose={true}
        onModalCancelClicked={() => props.setModalVisibility(false)}
        initialValues={props.initialValues}
        modalOkText={props.saveButtonTitle}
        modalCancelText={props.cancelButtonTitle}
        modalTitle={props.modalTitle}
        isModalVisible={props.isModalVisible}
    />;
}

interface ProductStatisticsModalProps {
    initialValues?: ProductStatisticsCreateDto | ProductStatisticsUpdateDto,
    isModalVisible: boolean;
    setModalVisibility: (isVisible: boolean) => any;
    onSubmit: (value: ProductStatisticsCreateDto | ProductStatisticsUpdateDto) => Promise<any>,
    modalTitle: string,
    saveButtonTitle: string,
    cancelButtonTitle: string;
}
